module.exports = __webpack_public_path__ + "static/media/event.2e738e19.png";